export * from './event.api.interfaces';
export * from '../controllers/events/interfaces';
export interface Award {
	name: string;
	imgUrl: string;
	isMedal?: boolean;
	description?: string; 
}
export interface Member {
	name: string;
	id: string;
	mainDivision: string;
	ranks: {
		name: string;
		division: string;
		category: string;
	};
	awards: {
		name: string;
		description: string;
	};
	administrativeRoles: {
		category: string;
		name: string;
	},
	img: string;
}
export interface Rank {
	name: string;
	category: string;
	group: string;
}
export interface AdminRoles {
	name: string;
	category: string;
	parent: {
		name: string;
		category: string;
	}
}

export interface Post {
	id: number,
	title: string,
	img: string,
	body: string,
	author: {
		name: string
	},
	date_created: Date,
	tags: Array<string>,
}

// For events



export interface ArrayObject {
	children?: Array<ArrayObject>;
	[propName: string]: any;
}



export interface DropdownOption {
    value: string;
    name: string;
}